import template from './mainMenu.html';
import controller from './mainMenu.controller';
import './mainMenu.scss';

let menuComponent = {
  restrict: 'E',
  transclude: true,
  bindings:{
    links: '<'
  },
  template,
  controller
};

export default menuComponent;



// WEBPACK FOOTER //
// ./client/app/components/mainMenu/mainMenu.component.js